(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentServiceItemAccessDetailController', AgentServiceItemAccessDetailController);

    AgentServiceItemAccessDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'AgentServiceItemAccess', 'ServiceItem', 'AgentAccessInfo'];

    function AgentServiceItemAccessDetailController($scope, $rootScope, $stateParams, entity, AgentServiceItemAccess, ServiceItem, AgentAccessInfo) {
        var vm = this;

        vm.agentServiceItemAccess = entity;

        var unsubscribe = $rootScope.$on('tikonApp:agentServiceItemAccessUpdate', function (event, result) {
            vm.agentServiceItemAccess = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
